var NotificationBase = require('../NotificationBase');

module.exports = NotificationBase.extend({
    flashNotification: false,
    severityDefault: 5,
    categoryDefault: 2,
    stickyDefault: 0,
    iconCls: 'ui-icon-star',
    getContent: function() {
        return jimdoData.messages.notifications.topicChangeNotification;
    },
    globalAction: function() {
        diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'industry'}
            ],
            true // demo mode active
        );
    },

    getName: function() {
        return 'TopicChangeNotification';
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/TopicChangeNotification.js
 ** module id = 655
 ** module chunks = 0
 **/